import ScrollReveal from "../components/ScrollReveal";
import FloatingHero3D from "../components/FloatingHero3D";
import StatsMarquee from "../components/sections/StatsMarquee";
import Process from "../components/sections/Process";
import CTASection from "../components/sections/CTASection";

const VALUES = [
  {
    title: "Craft over noise",
    body: "We'd rather ship one obsidian-sharp site than ten forgettable ones. Every detail is intentional.",
  },
  {
    title: "Speed is a feature",
    body: "3–5 day delivery isn't a gimmick — it's the outcome of a tight, battle-tested production system.",
  },
  {
    title: "Revenue-first design",
    body: "Beautiful doesn't matter if it doesn't convert. Every pixel is measured against the P&L.",
  },
  {
    title: "Founder-aligned",
    body: "We think like operators, not vendors. Your numbers are our numbers.",
  },
];

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="pt-36 md:pt-44 pb-20 md:pb-28 border-b border-white/10 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-12 items-center">
          <ScrollReveal>
            <div className="text-xs uppercase tracking-[0.4em] text-white/40 mb-4">
              / About
            </div>
            <h1 className="font-display text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[0.95]">
              Forged from<br /><span className="text-white/40">obsession.</span>
            </h1>
            <p className="mt-6 text-white/70 max-w-xl text-base md:text-lg leading-relaxed">
              OBSIDIAN MEDIA is a brand & web design studio for ecommerce
              founders who refuse to look like everyone else.
            </p>
            <p className="mt-5 text-white/55 max-w-xl leading-relaxed">
              Over 5 years we've shipped 150+ projects for 60+ brands across
              India and beyond. We specialise in Shopify, high-conversion
              websites, CRO, brand identity and social systems that scale.
            </p>
            <p className="mt-5 text-white/55 max-w-xl leading-relaxed">
              We don't do pitch decks or theatre. We show up, diagnose the real
              problem and ship work that moves numbers.
            </p>
          </ScrollReveal>

          <div className="relative h-[420px] md:h-[540px]">
            <FloatingHero3D compact />
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 md:py-32 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <ScrollReveal className="mb-14">
            <div className="text-xs uppercase tracking-[0.4em] text-white/40 mb-4">
              / Values
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight leading-[1] max-w-2xl">
              What we believe.
            </h2>
          </ScrollReveal>
          <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {VALUES.map((v, i) => (
              <ScrollReveal
                key={v.title}
                delay={i * 0.06}
                className="bg-[#080808] p-8 md:p-12"
              >
                <div className="font-display text-xs uppercase tracking-[0.3em] text-white/40 mb-3">
                  0{i + 1}
                </div>
                <h3 className="font-display text-2xl md:text-3xl font-extrabold uppercase tracking-tight mb-4">
                  {v.title}
                </h3>
                <p className="text-white/60 leading-relaxed">{v.body}</p>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      <StatsMarquee />
      <Process />
      <CTASection />
    </div>
  );
}
